// A listing of all the user's affiliations and current applications
import React, { useEffect, useMemo } from 'react';

import ExpLabel from '@exp/components/localization/ExpLabel';
import Tooltip, { PLACEMENT, TRIGGER } from '@exp/components/common/Tooltip';
import { useIsMediaMD } from '@exp/hooks/useMediaQuery';

import { ModeContext } from '../constants/modes';
import { fetchUserAffiliations, selectContext } from '../redux/context';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { affiliationSort, filterAffiliations } from '../utilities/utilities';
import AffiliationCard from './AffiliationCard';

import './AffiliationListing.less';

const AffiliationListing = () => {
  const dispatch = useAppDispatch();
  const { affiliations }: ModeContext = useAppSelector(selectContext);
  const sortedAffiliations = useMemo(() => [...(affiliations || [])].sort(affiliationSort), [affiliations]);
  const isMD = useIsMediaMD();

  useEffect(() => {
    dispatch(fetchUserAffiliations(true));
  }, [dispatch]);

  return (
    <div className="affiliations-list">
      {isMD && (
        <header className="affiliations-list-header">
          <ExpLabel defaultMessage="My Teams" messageKey="onb.affiliationsList.header" tagName="h2" />
          <Tooltip
            autoCloseDelay={3000}
            body={
              <ExpLabel
                defaultMessage="Keep track of all your teams and status on this page. You may be asked to resubmit your qualifications to confirm you're still part of a  team. So keep an eye on your status to maintain access and perks!"
                messageKey="onb.affiliationsList.tooltip"
              />
            }
            className="affiliations-list-tooltip"
            placement={PLACEMENT.BOTTOM}
            trigger={TRIGGER.CLICK}
          >
            <i className="exp-ux-small exp-ux-info" />
          </Tooltip>
        </header>
      )}
      <div className="affiliations">
        {sortedAffiliations?.filter(filterAffiliations).map((a) => (
          <AffiliationCard affiliation={a} key={a.teamId} />
        ))}
      </div>
    </div>
  );
};

AffiliationListing.displayName = 'AffiliationListing';

export default AffiliationListing;
